import { useState, useRef, useCallback, FC, useEffect, Fragment } from 'react';
import { isAndroid, isChrome, isFirefox } from 'react-device-detect';
import Webcam from "react-webcam";
import { Card } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Camera from '@material-ui/icons/Camera';

import LeftArrow from '../../assets/img/leftArrow';
import { Image, StyledMotionImages, StyledMotions, StyledTextContainer } from '../../styles/globalStyle';
import useStyles from "../../styles/index";
import useSelfieStyles from "../../styles/selfieStyles";


export interface ISelfieithMovement {

    showVideo: boolean;
    state: any;
    onValue: (value: string[]) => void;

}

const SelfieiWithText: FC<ISelfieithMovement> = ({ showVideo, state, onValue }) => {


    const webcamRef = useRef<any>(null);
    const mediaRecorderRef = useRef<MediaRecorder | null>(null);
    const [capturing, setCapturing] = useState(false);

    const [recordedChunks, setRecordedChunks] = useState([]);

    const [remainSeconds, setRemainSeconds] = useState(10);

    const selfieClasses = useSelfieStyles();




    useEffect(() => {

        if (recordedChunks && recordedChunks.length > 0) {

            onValue(recordedChunks);
        }
    }, [recordedChunks])


    const start = (event: any) => {

        event.preventDefault();


        startCapturing();




        let x = 10;
        let loopArray = function () {


            x--;

            if (x === 0) {

                stopCapturing();
                setRemainSeconds(10);

                return;
            }

            if (x <= 10 && x >= 0) {

                setTimeout(() => {

                    setRemainSeconds(x);
                    loopArray();

                }, 1000)

            }

        }



        loopArray();



    };

    const stopCapturing = useCallback(() => {
        if (mediaRecorderRef?.current) {

            // window.clearInterval(timer.current!);
            mediaRecorderRef.current!.stop();
            setCapturing(false);
        }
    }, [mediaRecorderRef, webcamRef, setCapturing]);


    const handleDataAvailable = useCallback(
        ({ data }) => {
            if (data.size > 0) {
                setRecordedChunks((prev) => prev.concat(data));
            }
        },
        [setRecordedChunks, recordedChunks]
    );


    const startCapturing = useCallback(() => {
        setCapturing(true);
        if (webcamRef?.current?.stream) {


            mediaRecorderRef.current = new MediaRecorder(webcamRef?.current?.stream,
                {
                    mimeType: MediaRecorder.isTypeSupported('video/webm') ? 'video/webm' : 'video/mp4; codecs=avc1.424028, mp4a.40.2',
                }
            );
            mediaRecorderRef.current.addEventListener(
                "dataavailable",
                handleDataAvailable
            );
            mediaRecorderRef.current.start();
        }

    }, [webcamRef, mediaRecorderRef, setCapturing]);





    return (
        <>
            <Webcam
                className={selfieClasses.video}
                ref={webcamRef}
                mirrored={true}
                audio={true}
                videoConstraints={{
                    width: { min: 640, ideal: 1920 },
                    height: { min: 400, ideal: 1080 },
                    facingMode: "user",
                }}
            />
            <img
                className={selfieClasses.frame}
                src="./frame.png"
                alt="frame"
            />
            <Card className={selfieClasses.numbers}>
                {/* {authType === "byVoice"
                    ? state.selfieText
                    : state.selfieHeadDirec} */}
                {/* {state.selfieHeadDirec} */}

                <StyledMotions>
                    <StyledTextContainer>

                        <div
                            style={{ display: 'flex', alignItems: 'center', flexDirection: 'row-reverse' }}
                        >
                            {
                                state?.selfieText.split('-').reverse().map((_number: string, index: number) => (
                                    <Fragment key={index.toString()}
                                    >

                                        <span style={{ padding: '4px', fontSize: '24px', fontWeight: 'bold' }}>{_number}</span>

                                        {
                                            index !== state?.selfieText.split('-').length - 1 && <LeftArrow className={'text__arrow'} />
                                        }


                                    </Fragment>

                                ))
                            }

                        </div>





                    </StyledTextContainer>


                </StyledMotions>




            </Card>

            <div
                className={selfieClasses.videoButtons}
                style={{ bottom: showVideo ? "350px" : '5px' }}
            >

                <Button
                    variant="contained"
                    size="large"
                    startIcon={<Camera />}
                    onClick={capturing ? () => { return; } : start}
                >
                    شروع
                    <div>00:{remainSeconds}</div>
                </Button>
            </div>
        </>

    );
};

export default SelfieiWithText;